<template>
  <v-card tile :elevation="0" >
    <v-list class="py-1">
      <template v-for="(itemMenu, index) in MenuPush" :key="index">
        <MenuItemDrawer :item="itemMenu" :basePath="'/'" />
      </template>
    </v-list>
  </v-card>
</template>

<style scoped>
.v-navigation-drawer--active {
  margin: 0;
  padding: 0;
  width:90vw !important;
  background-color: white; 
}

.v-list {
  margin: 0;
  padding: 0;
}
</style>
<script setup>
import MenuItemDrawer from '@/components/App/MenuItemDrawer.vue';
const dataAll = useDataAll();
const MenuPush = usePageOverviewStore().PageOverview;
// const opened = ref([]);
</script>